// extracted by mini-css-extract-plugin
module.exports = {"footer":"StepsFooter-module__footer___3AsZk","step":"StepsFooter-module__step___qc2vW","active":"StepsFooter-module__active___vd91j"};